const ExcessType = {
  None: 'None',
  LegalExcess: 'LegalExcess',
  EnglishExcess: 'EnglishExcess',
};

export default ExcessType;
